import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-ods-checkbox',
  templateUrl: './ods-checkbox.component.html',
  styleUrls: ['./ods-checkbox.component.scss'],
})
export class OdsCheckboxComponent {
  @Input() checkboxId: string;
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Input() error: boolean = false;
  @Input() compact: boolean = false;
  @Input() preview: boolean = false;
  @Input() ariaLabel: string | null = null;
  @Output() checkedChange = new EventEmitter<boolean>();

  onToggle(event: Event): void {
    this.checked = (event.target as HTMLInputElement).checked;
    this.checkedChange.emit(this.checked);
  }
}
